module.exports = __webpack_public_path__ + "fromGroomToFather-we-n.ebd4d970.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/fromGroomToFather-we-n.jpg
// module id = oEev
// module chunks = 0